import {
  Component,
  Input,
  OnDestroy,
  Inject,
  ViewEncapsulation,
} from "@angular/core";
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { CommonService } from "../views/common/services/common.service";

@Component({
  selector: "custom-spinner",
  template: `<div
    style="    position: absolute;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    background: white;
    z-index: 99999;
    opacity: 50%;"
    *ngIf="isSpinnerVisible"
  >
    <div
      style="
      position: relative;
    top: 50%;
    left: 46%;
    color: black;
    font-weight: bold;"
    >
      Please Wait...
    </div>
    <div
      style="width: 40px;height: 40px;top: 25%;position: relative;margin: 100px auto;"
    >
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  </div>`,
  encapsulation: ViewEncapsulation.None,
})
export class CustomSpinnerComponent {
  public isSpinnerVisible = false;

  @Input() public backgroundColor = "rgba(0, 115, 170, 0.69)";

  constructor(
    private router: Router,
    private comonServ: CommonService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.comonServ.isLoadingStream$.subscribe((res: boolean) => {
      this.isSpinnerVisible = res;
    });

    // this.router.events.subscribe(
    //   (event) => {
    //     if (event instanceof NavigationStart) {
    //       this.isSpinnerVisible = true;
    //     } else if (
    //       event instanceof NavigationEnd ||
    //       event instanceof NavigationCancel ||
    //       event instanceof NavigationError
    //     ) {
    //       this.isSpinnerVisible = false;
    //     }
    //   },
    //   () => {
    //     this.isSpinnerVisible = false;
    //   }
    // );
  }

  // ngOnDestroy(): void {
  // this.isSpinnerVisible = false;
  // }
}
